import type * as Types from "./types";
import type { DocumentNode, ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
export const MoneyFragmentFragmentDoc = gql`
    fragment MoneyFragment on Money {
  currencyCode
  centAmount
  fractionDigits
  type
}
    `;
export const ProductFragmentFragmentDoc = gql`
    fragment ProductFragment on LineItem {
  id
  productId
  productKey
  name(locale: $locale)
  addedAt
  discountedPricePerQuantity {
    quantity
    discountedPrice {
      includedDiscounts {
        discount {
          id
          key
        }
        discountedAmount {
          centAmount
          currencyCode
          type
          fractionDigits
        }
      }
    }
  }
  variant {
    sku
    images {
      label
      url
    }
    availability {
      channels {
        results {
          availability {
            isOnStock
            availableQuantity
          }
          channel {
            key
            id
          }
        }
      }
    }
    attributesRaw(
      includeNames: ["ArticleNumber", "ColorCode", "Size", "Size_CN", "Size_US", "Size_UK", "Size_KR", "Size_JP", "Size_CA", "MaterialGroupLocalized", "DominantColor", "BackgroundColor", "DescriptiveHeading", "Division", "CollectionType", "CollectionClass", "CollectionSegment", "PageTitle", "ProductVideo", "InteractiveVideo"]
    ) {
      name
      value
    }
  }
  supplyChannel {
    id
    key
  }
  quantity
  price {
    value {
      ...MoneyFragment
    }
    discounted {
      value {
        ...MoneyFragment
      }
    }
    custom {
      customFieldsRaw(
        includeNames: ["price_CF_RecommendedRetailPrice", "price_CF_DiscountPercentage", "price_CF_AdjustedPrice", "price_CF_OfferIds"]
      ) {
        name
        value
      }
    }
  }
  totalPrice {
    ...MoneyFragment
  }
}
    ${MoneyFragmentFragmentDoc}`;
export const PaymentFragmentFragmentDoc = gql`
    fragment PaymentFragment on Payment {
  id
  paymentMethodInfo {
    method
    name(locale: $locale)
  }
}
    `;
export const CartFragmentFragmentDoc = gql`
    fragment CartFragment on Cart {
  id
  anonymousId
  version
  country
  customer {
    email
    custom {
      customFieldsRaw(
        includeNames: ["customer_CF_PhoneCountryCode", "customer_CF_PhoneNumber"]
      ) {
        name
        value
      }
    }
  }
  lineItems {
    custom {
      customFieldsRaw(
        includeNames: ["line-item_CF_Price", "line-item_CF_DiscountedPrice"]
      ) {
        name
        value
      }
    }
    ...ProductFragment
  }
  totalPrice {
    ...MoneyFragment
  }
  taxedPrice {
    totalGross {
      ...MoneyFragment
    }
    totalTax {
      ...MoneyFragment
    }
  }
  totalLineItemQuantity
  custom {
    customFieldsRaw(
      includeNames: ["order_CF_HasDiscount", "order_CF_DiscountedPrice", "order_CF_Price", "order_CF_Discount", "order_CF_ShopperFirstName", "order_CF_ShopperLastName", "order_CF_DiscountedPriceValue", "order_CF_DeliveryDate", "order_CF_DeliveryTimeSlot"]
    ) {
      name
      value
    }
  }
  directDiscounts {
    id
    value {
      type
    }
  }
  discountCodes {
    state
    discountCode {
      id
      cartDiscounts {
        id
      }
      code
      name(locale: $locale)
      key
    }
  }
  shippingAddress {
    firstName
    lastName
    phone
    email
    streetName
    additionalAddressInfo
    postalCode
    city
    region
    country
    company
    salutation
    custom {
      customFieldsRaw(
        includeNames: ["address_CF_Landmark", "address_CF_DeliveryInstructions", "address_CF_PhoneticFirstName", "address_CF_PhoneticLastName", "address_CF_ParcelShopId", "address_CF_ParcelShopCarrier", "address_CF_VatId", "address_CF_IsCompany", "address_CF_CustomerNumber"]
      ) {
        name
        value
      }
    }
  }
  billingAddress {
    firstName
    lastName
    streetName
    additionalAddressInfo
    postalCode
    city
    phone
    region
    country
    company
    salutation
    custom {
      customFieldsRaw(
        includeNames: ["address_CF_PhoneticFirstName", "address_CF_PhoneticLastName", "address_CF_VatId", "address_CF_IsCompany", "address_CF_CustomerNumber"]
      ) {
        name
        value
      }
    }
  }
  shippingInfo {
    price {
      ...MoneyFragment
    }
    shippingMethod {
      key
      name
    }
    shippingMethodName
    discountedPrice {
      value {
        ...MoneyFragment
      }
      includedDiscounts {
        discount {
          id
        }
        discountedAmount {
          centAmount
          currencyCode
          type
          fractionDigits
        }
      }
    }
  }
  paymentInfo {
    payments {
      ...PaymentFragment
    }
  }
  store {
    key
  }
  createdAt
}
    ${ProductFragmentFragmentDoc}
${MoneyFragmentFragmentDoc}
${PaymentFragmentFragmentDoc}`;
export const AddressFragmentFragmentDoc = gql`
    fragment AddressFragment on Address {
  id
  firstName
  lastName
  streetName
  additionalAddressInfo
  postalCode
  city
  country
  externalId
  key
  region
  company
  salutation
  custom {
    customFieldsRaw(
      includeNames: ["address_CF_EccoAddressName", "address_CF_Landmark", "address_CF_DeliveryInstructions", "address_CF_ParcelShopId", "address_CF_ParcelShopCarrier", "address_CF_VatId", "address_CF_IsCompany", "address_CF_CustomerNumber"]
    ) {
      name
      value
    }
  }
}
    `;
export const CustomerAddressesFragmentFragmentDoc = gql`
    fragment CustomerAddressesFragment on Customer {
  id
  version
  addresses {
    ...AddressFragment
  }
  defaultShippingAddressId
}
    ${AddressFragmentFragmentDoc}`;
export const ShippingMethodFragmentFragmentDoc = gql`
    fragment ShippingMethodFragment on ShippingMethod {
  name
  key
  custom {
    customFieldsRaw(
      includeNames: ["shippingmethod_CF_OrderType", "shippingmethod_CF_DeliveryTime"]
    ) {
      name
      value
    }
  }
}
    `;
export const ShoppingListProductFragmentFragmentDoc = gql`
    fragment ShoppingListProductFragment on ShoppingListLineItem {
  id
  productId
  addedAt
  name(locale: $locale)
  variant {
    sku
    images {
      label
      url
    }
    attributesRaw(
      includeNames: ["ArticleNumber", "ColorCode", "Size", "Size_CN", "Size_US", "MaterialGroupLocalized", "Size_UK", "Size_KR", "Size_JP", "Size_CA", "DominantColor", "BackgroundColor", "DescriptiveHeading", "Division", "CollectionType", "CollectionClass", "CollectionSegment", "PageTitle"]
    ) {
      name
      value
    }
  }
  quantity
}
    `;
export const WishlistFragmentFragmentDoc = gql`
    fragment WishlistFragment on ShoppingList {
  id
  anonymousId
  version
  createdAt
  customer {
    id
    email
    firstName
    lastName
  }
  lineItems {
    ...ShoppingListProductFragment
  }
  store {
    key
  }
}
    ${ShoppingListProductFragmentFragmentDoc}`;
export const EccoCreateMyCartDocument = gql`
    mutation eccoCreateMyCart($storeKey: KeyReferenceInput!, $currency: Currency!, $country: Country!, $locale: Locale!) {
  createMyCart(
    draft: {locale: $locale, currency: $currency, country: $country, lineItems: [], shippingAddress: {country: $country, firstName: "", lastName: "", streetName: "", additionalAddressInfo: "", postalCode: "", city: "", phone: "", email: "", region: ""}}
    storeKey: $storeKey
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const EccoAddProductToCartDocument = gql`
    mutation eccoAddProductToCart($cartId: String!, $cartVersion: Long!, $storeKey: KeyReferenceInput!, $sku: String!, $quantity: Long!, $distributionChannel: String!, $supplyChannel: ResourceIdentifierInput, $locale: Locale!) {
  updateMyCart(
    id: $cartId
    version: $cartVersion
    storeKey: $storeKey
    actions: [{addLineItem: {sku: $sku, quantity: $quantity, distributionChannel: {typeId: "channel", key: $distributionChannel}, supplyChannel: $supplyChannel}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const EccoUpdateLineItemSupplyChannelDocument = gql`
    mutation eccoUpdateLineItemSupplyChannel($cartId: String!, $cartVersion: Long!, $storeKey: KeyReferenceInput!, $supplyChannel: ResourceIdentifierInput, $locale: Locale!, $lineItemId: String!) {
  updateMyCart(
    id: $cartId
    version: $cartVersion
    storeKey: $storeKey
    actions: [{setLineItemSupplyChannel: {lineItemId: $lineItemId, supplyChannel: $supplyChannel}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const EccoUpdateShopperNameCustomFieldsCartDocument = gql`
    mutation eccoUpdateShopperNameCustomFieldsCart($version: Long!, $id: String!, $storeKey: KeyReferenceInput!, $firstName: String!, $lastName: String!, $locale: Locale!) {
  updateMyCart(
    version: $version
    id: $id
    storeKey: $storeKey
    actions: [{setCustomField: {name: "order_CF_ShopperFirstName", value: $firstName}}, {setCustomField: {name: "order_CF_ShopperLastName", value: $lastName}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const EccoRemoveProductFromCartDocument = gql`
    mutation eccoRemoveProductFromCart($lineItemId: String!, $quantity: Long!, $cartId: String!, $cartVersion: Long!, $storeKey: KeyReferenceInput!, $locale: Locale!) {
  updateMyCart(
    id: $cartId
    version: $cartVersion
    storeKey: $storeKey
    actions: [{removeLineItem: {lineItemId: $lineItemId, quantity: $quantity}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const EccoAddDeliveryAddressToMyCartDocument = gql`
    mutation eccoAddDeliveryAddressToMyCart($version: Long!, $id: String!, $storeKey: KeyReferenceInput!, $country: Country!, $firstName: String, $lastName: String, $streetName: String, $additionalAddressInfo: String, $postalCode: String, $city: String, $phone: String, $email: String, $locale: Locale!, $region: String, $company: String, $salutation: String, $customFields: [CustomFieldInput!]) {
  updateMyCart(
    version: $version
    id: $id
    storeKey: $storeKey
    actions: [{setShippingAddress: {address: {country: $country, firstName: $firstName, lastName: $lastName, streetName: $streetName, additionalAddressInfo: $additionalAddressInfo, postalCode: $postalCode, city: $city, phone: $phone, email: $email, region: $region, company: $company, salutation: $salutation, custom: {fields: $customFields, typeKey: "address-customfields-type"}}}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const EccoAddDeliveryDateAndTimeSlotToCartDocument = gql`
    mutation eccoAddDeliveryDateAndTimeSlotToCart($version: Long!, $id: String!, $storeKey: KeyReferenceInput!, $date: String!, $timeslot: String!, $locale: Locale!) {
  updateMyCart(
    version: $version
    id: $id
    storeKey: $storeKey
    actions: [{setCustomField: {name: "order_CF_DeliveryDate", value: $date}}, {setCustomField: {name: "order_CF_DeliveryTimeSlot", value: $timeslot}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const EccoAddShippingMethodToCartDocument = gql`
    mutation eccoAddShippingMethodToCart($version: Long!, $id: String!, $storeKey: KeyReferenceInput!, $shippingMethod: String!, $locale: Locale!) {
  updateMyCart(
    version: $version
    id: $id
    storeKey: $storeKey
    actions: [{setShippingMethod: {shippingMethod: {typeId: "shipping-method", key: $shippingMethod}}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const EccoAddBillingAddressToMyCartDocument = gql`
    mutation eccoAddBillingAddressToMyCart($version: Long!, $id: String!, $storeKey: KeyReferenceInput!, $country: Country!, $firstName: String!, $lastName: String!, $streetName: String!, $additionalAddressInfo: String, $phone: String, $postalCode: String!, $city: String!, $email: String!, $locale: Locale!, $region: String, $company: String, $customFields: [CustomFieldInput!]) {
  updateMyCart(
    version: $version
    id: $id
    storeKey: $storeKey
    actions: [{setBillingAddress: {address: {country: $country, firstName: $firstName, lastName: $lastName, streetName: $streetName, additionalAddressInfo: $additionalAddressInfo, postalCode: $postalCode, phone: $phone, city: $city, email: $email, region: $region, company: $company, custom: {fields: $customFields, typeKey: "address-customfields-type"}}}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const EccoAddDiscountToCartDocument = gql`
    mutation eccoAddDiscountToCart($discountCode: String!, $cartId: String!, $cartVersion: Long!, $storeKey: KeyReferenceInput!, $locale: Locale!) {
  updateMyCart(
    id: $cartId
    version: $cartVersion
    storeKey: $storeKey
    actions: [{addDiscountCode: {code: $discountCode}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const EccoRemoveDiscountFromCartDocument = gql`
    mutation eccoRemoveDiscountFromCart($discountId: String!, $typeId: String!, $cartId: String!, $cartVersion: Long!, $storeKey: KeyReferenceInput!, $locale: Locale!) {
  updateMyCart(
    id: $cartId
    version: $cartVersion
    storeKey: $storeKey
    actions: [{removeDiscountCode: {discountCode: {typeId: $typeId, id: $discountId}}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const ChangeProductQuantityInCartDocument = gql`
    mutation changeProductQuantityInCart($lineItemId: String!, $quantity: Long!, $cartId: String!, $cartVersion: Long!, $storeKey: KeyReferenceInput!, $locale: Locale!) {
  updateMyCart(
    id: $cartId
    version: $cartVersion
    storeKey: $storeKey
    actions: [{changeLineItemQuantity: {lineItemId: $lineItemId, quantity: $quantity}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const ChangeProductSizeInCartDocument = gql`
    mutation changeProductSizeInCart($lineItemId: String!, $sku: String!, $distributionChannel: String!, $cartId: String!, $cartVersion: Long!, $storeKey: KeyReferenceInput!, $supplyChannel: ResourceIdentifierInput, $locale: Locale!, $quantity: Long!, $addedAt: DateTime!) {
  updateMyCart(
    id: $cartId
    version: $cartVersion
    storeKey: $storeKey
    actions: [{removeLineItem: {lineItemId: $lineItemId}}, {addLineItem: {sku: $sku, quantity: $quantity, addedAt: $addedAt, distributionChannel: {typeId: "channel", key: $distributionChannel}, supplyChannel: $supplyChannel}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const ChangeProductSizeToExistOneInCartDocument = gql`
    mutation changeProductSizeToExistOneInCart($lineItemIdToRemove: String!, $lineItemIdToChange: String!, $cartId: String!, $cartVersion: Long!, $storeKey: KeyReferenceInput!, $quantity: Long!, $locale: Locale!) {
  updateMyCart(
    id: $cartId
    version: $cartVersion
    storeKey: $storeKey
    actions: [{removeLineItem: {lineItemId: $lineItemIdToRemove}}, {changeLineItemQuantity: {lineItemId: $lineItemIdToChange, quantity: $quantity}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const RecalculateCartDocument = gql`
    mutation recalculateCart($cartId: String!, $cartVersion: Long!, $storeKey: KeyReferenceInput!, $locale: Locale!) {
  updateMyCart(
    id: $cartId
    version: $cartVersion
    storeKey: $storeKey
    actions: [{recalculate: {updateProductData: true}}]
  ) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const AddAddressToCustomerDocument = gql`
    mutation addAddressToCustomer($version: Long!, $storeKey: KeyReferenceInput!, $country: Country!, $firstName: String!, $lastName: String!, $streetName: String!, $postalCode: String!, $additionalAddressInfo: String, $city: String!, $region: String, $key: String, $title: String, $addressName: String!) {
  updateMyCustomer(
    version: $version
    storeKey: $storeKey
    actions: [{addAddress: {address: {key: $key, country: $country, firstName: $firstName, lastName: $lastName, streetName: $streetName, additionalAddressInfo: $additionalAddressInfo, postalCode: $postalCode, city: $city, region: $region, custom: {fields: [{name: "address_CF_EccoAddressName", value: $addressName}], typeKey: "address-customfields-type"}}}, setCustomField: {name: "customer_CF_LastUpdateByMasterData", value: "false"}, setTitle: {title: $title}}]
  ) {
    ...CustomerAddressesFragment
  }
}
    ${CustomerAddressesFragmentFragmentDoc}`;
export const UpdateAddressToCustomerDocument = gql`
    mutation updateAddressToCustomer($version: Long!, $storeKey: KeyReferenceInput!, $addressId: String!, $country: Country!, $firstName: String!, $lastName: String!, $streetName: String!, $postalCode: String!, $additionalAddressInfo: String, $city: String!, $region: String, $externalId: String, $addressName: String!, $title: String, $key: String) {
  updateMyCustomer(
    version: $version
    storeKey: $storeKey
    actions: [{changeAddress: {addressId: $addressId, address: {country: $country, firstName: $firstName, lastName: $lastName, streetName: $streetName, additionalAddressInfo: $additionalAddressInfo, postalCode: $postalCode, city: $city, region: $region, externalId: $externalId, key: $key, custom: {fields: [{name: "address_CF_EccoAddressName", value: $addressName}], typeKey: "address-customfields-type"}}}, setCustomField: {name: "customer_CF_LastUpdateByMasterData", value: "false"}, setTitle: {title: $title}}]
  ) {
    ...CustomerAddressesFragment
  }
}
    ${CustomerAddressesFragmentFragmentDoc}`;
export const UpdateDefaultShippingAddressToCustomerDocument = gql`
    mutation updateDefaultShippingAddressToCustomer($version: Long!, $storeKey: KeyReferenceInput!, $addressId: String!, $country: Country!, $firstName: String!, $lastName: String!, $streetName: String!, $postalCode: String!, $additionalAddressInfo: String, $city: String!, $region: String, $externalId: String, $key: String, $title: String!, $addressName: String!) {
  updateMyCustomer(
    version: $version
    storeKey: $storeKey
    actions: [{changeAddress: {addressId: $addressId, address: {country: $country, firstName: $firstName, lastName: $lastName, streetName: $streetName, additionalAddressInfo: $additionalAddressInfo, postalCode: $postalCode, city: $city, region: $region, externalId: $externalId, key: $key, custom: {fields: [{name: "address_CF_EccoAddressName", value: $addressName}], typeKey: "address-customfields-type"}}}, setDefaultShippingAddress: {addressId: $addressId}, setCustomField: {name: "customer_CF_LastUpdateByMasterData", value: "false"}, setTitle: {title: $title}}]
  ) {
    ...CustomerAddressesFragment
  }
}
    ${CustomerAddressesFragmentFragmentDoc}`;
export const AddDefaultShippingAddressToCustomerDocument = gql`
    mutation addDefaultShippingAddressToCustomer($version: Long!, $storeKey: KeyReferenceInput!, $country: Country!, $firstName: String!, $lastName: String!, $streetName: String!, $postalCode: String!, $additionalAddressInfo: String, $city: String!, $region: String, $key: String!, $title: String!, $addressName: String!) {
  updateMyCustomer(
    version: $version
    storeKey: $storeKey
    actions: [{addAddress: {address: {key: $key, country: $country, firstName: $firstName, lastName: $lastName, streetName: $streetName, additionalAddressInfo: $additionalAddressInfo, postalCode: $postalCode, city: $city, region: $region, custom: {fields: [{name: "address_CF_EccoAddressName", value: $addressName}], typeKey: "address-customfields-type"}}}, setDefaultShippingAddress: {addressKey: $key}, setCustomField: {name: "customer_CF_LastUpdateByMasterData", value: "false"}, setTitle: {title: $title}}]
  ) {
    ...CustomerAddressesFragment
  }
}
    ${CustomerAddressesFragmentFragmentDoc}`;
export const RemoveAddressByIdDocument = gql`
    mutation removeAddressById($version: Long!, $storeKey: KeyReferenceInput!, $addressId: String!) {
  updateMyCustomer(
    version: $version
    storeKey: $storeKey
    actions: [{removeAddress: {addressId: $addressId}, setCustomField: {name: "customer_CF_LastUpdateByMasterData", value: "false"}}]
  ) {
    ...CustomerAddressesFragment
  }
}
    ${CustomerAddressesFragmentFragmentDoc}`;
export const SetDefaultShippingAddressByIdDocument = gql`
    mutation setDefaultShippingAddressById($version: Long!, $storeKey: KeyReferenceInput!, $addressId: String!, $title: String!) {
  updateMyCustomer(
    version: $version
    storeKey: $storeKey
    actions: [{setDefaultShippingAddress: {addressId: $addressId}, setTitle: {title: $title}, setCustomField: {name: "customer_CF_LastUpdateByMasterData", value: "false"}}]
  ) {
    ...CustomerAddressesFragment
  }
}
    ${CustomerAddressesFragmentFragmentDoc}`;
export const CreateMyWishlistDocument = gql`
    mutation createMyWishlist($storeKey: KeyReferenceInput!, $locale: Locale!, $value: String!) {
  createMyShoppingList(
    draft: {name: [{locale: $locale, value: $value}], lineItems: []}
    storeKey: $storeKey
  ) {
    ...WishlistFragment
  }
}
    ${WishlistFragmentFragmentDoc}`;
export const DeleteMyWishlistDocument = gql`
    mutation deleteMyWishlist($shoppingListId: String!, $shoppingListVersion: Long!, $storeKey: KeyReferenceInput!, $locale: Locale!) {
  deleteMyShoppingList(
    id: $shoppingListId
    version: $shoppingListVersion
    storeKey: $storeKey
  ) {
    ...WishlistFragment
  }
}
    ${WishlistFragmentFragmentDoc}`;
export const AddProductToWishlistDocument = gql`
    mutation addProductToWishlist($shoppingListId: String!, $shoppingListVersion: Long!, $storeKey: KeyReferenceInput!, $sku: String!, $quantity: Int!, $locale: Locale!) {
  updateMyShoppingList(
    id: $shoppingListId
    version: $shoppingListVersion
    storeKey: $storeKey
    actions: [{addLineItem: {sku: $sku, quantity: $quantity}}]
  ) {
    ...WishlistFragment
  }
}
    ${WishlistFragmentFragmentDoc}`;
export const AddProductAndRemoveOldestDocument = gql`
    mutation addProductAndRemoveOldest($oldestItemId: String!, $oldestItemQuantity: Int!, $sku: String!, $shoppingListId: String!, $shoppingListVersion: Long!, $storeKey: KeyReferenceInput!, $locale: Locale!) {
  updateMyShoppingList(
    id: $shoppingListId
    version: $shoppingListVersion
    storeKey: $storeKey
    actions: [{removeLineItem: {lineItemId: $oldestItemId, quantity: $oldestItemQuantity}}, {addLineItem: {sku: $sku, quantity: 1}}]
  ) {
    ...WishlistFragment
  }
}
    ${WishlistFragmentFragmentDoc}`;
export const RemoveProductFromWishlistDocument = gql`
    mutation removeProductFromWishlist($lineItemId: String!, $quantity: Int!, $shoppingListId: String!, $shoppingListVersion: Long!, $storeKey: KeyReferenceInput!, $locale: Locale!) {
  updateMyShoppingList(
    id: $shoppingListId
    version: $shoppingListVersion
    storeKey: $storeKey
    actions: [{removeLineItem: {lineItemId: $lineItemId, quantity: $quantity}}]
  ) {
    ...WishlistFragment
  }
}
    ${WishlistFragmentFragmentDoc}`;
export const ChangeQuantityInWishlistDocument = gql`
    mutation changeQuantityInWishlist($lineItemId: String!, $quantity: Int!, $shoppingListId: String!, $shoppingListVersion: Long!, $storeKey: KeyReferenceInput!, $locale: Locale!) {
  updateMyShoppingList(
    id: $shoppingListId
    version: $shoppingListVersion
    storeKey: $storeKey
    actions: [{changeLineItemQuantity: {lineItemId: $lineItemId, quantity: $quantity}}]
  ) {
    ...WishlistFragment
  }
}
    ${WishlistFragmentFragmentDoc}`;
export const ChangeProductSizeInWishlistDocument = gql`
    mutation changeProductSizeInWishlist($lineItemId: String!, $sku: String!, $shoppingListId: String!, $shoppingListVersion: Long!, $storeKey: KeyReferenceInput!, $locale: Locale!, $addedAt: DateTime!) {
  updateMyShoppingList(
    id: $shoppingListId
    version: $shoppingListVersion
    storeKey: $storeKey
    actions: [{removeLineItem: {lineItemId: $lineItemId}}, {addLineItem: {sku: $sku, quantity: 1, addedAt: $addedAt}}]
  ) {
    ...WishlistFragment
  }
}
    ${WishlistFragmentFragmentDoc}`;
export const EccoGetMyActiveCartDocument = gql`
    query eccoGetMyActiveCart($locale: Locale!) {
  me {
    activeCart {
      ...CartFragment
    }
  }
}
    ${CartFragmentFragmentDoc}`;
export const EccoGetMyActiveDataDocument = gql`
    query eccoGetMyActiveData($locale: Locale!) {
  me {
    activeCart {
      ...CartFragment
    }
    shoppingLists(limit: 10) {
      results {
        ...WishlistFragment
      }
    }
  }
}
    ${CartFragmentFragmentDoc}
${WishlistFragmentFragmentDoc}`;
export const GetCompactOrderDocument = gql`
    query getCompactOrder($id: String!, $locale: Locale!) {
  me {
    order(id: $id) {
      id
      orderNumber
      lineItems {
        productKey
        name(locale: $locale)
        variant {
          sku
          attributesRaw(
            includeNames: ["Size", "Size_CN", "Size_US", "MaterialGroupLocalized", "Size_UK", "Size_KR", "Size_JP", "Size_CA", "DominantColor"]
          ) {
            name
            value
          }
        }
        quantity
        price {
          value {
            ...MoneyFragment
          }
          discounted {
            value {
              ...MoneyFragment
            }
          }
        }
        totalPrice {
          ...MoneyFragment
        }
      }
      taxedPrice {
        totalTax {
          ...MoneyFragment
        }
      }
      totalPrice {
        ...MoneyFragment
      }
      shippingInfo {
        price {
          ...MoneyFragment
        }
      }
    }
  }
}
    ${MoneyFragmentFragmentDoc}`;
export const GetMultipleProductVariantsBySkusDocument = gql`
    query getMultipleProductVariantsBySkus($locale: Locale, $skus: [String!], $currency: Currency!) {
  products(skus: $skus) {
    results {
      key
      masterData {
        current {
          name(locale: $locale)
          description(locale: $locale)
          masterVariant {
            sku
          }
          variants(skus: $skus) {
            sku
            attributesRaw {
              name
              value
            }
            images {
              url
              label
              dimensions {
                width
                height
              }
            }
            price(currency: $currency) {
              value {
                currencyCode
                fractionDigits
                centAmount
              }
              discounted {
                value {
                  currencyCode
                  fractionDigits
                  centAmount
                }
              }
            }
          }
        }
        published
      }
    }
  }
}
    `;
export const GetMultipleProductsDocument = gql`
    query getMultipleProducts($locale: Locale, $channelId: String!, $country: Country!, $currency: Currency!, $skus: [String!]) {
  products(skus: $skus) {
    results {
      key
      masterData {
        current {
          name(locale: $locale)
          description(locale: $locale)
          masterVariant {
            sku
            attributesRaw {
              name
              value
            }
            images {
              url
              label
              dimensions {
                width
                height
              }
            }
            assets {
              name(locale: $locale)
            }
          }
          variants(isOnStock: true, hasImages: true, stockChannelIds: [$channelId]) {
            sku
            attributesRaw {
              name
              value
            }
            availability {
              channels(includeChannelIds: [$channelId]) {
                results {
                  availability {
                    isOnStock
                  }
                }
              }
            }
            prices {
              value {
                currencyCode
                fractionDigits
                centAmount
              }
            }
            price(channelId: $channelId, currency: $currency, country: $country) {
              value {
                currencyCode
                fractionDigits
                centAmount
              }
              discounted {
                value {
                  currencyCode
                  fractionDigits
                  centAmount
                }
              }
            }
          }
        }
        published
      }
    }
  }
}
    `;
export const EccoGetProductByKeyDocument = gql`
    query eccoGetProductByKey($key: String!, $storeKey: KeyReferenceInput!, $channelId: String!, $country: Country!, $distributionChannelWhereClause: String!, $locale: Locale!, $currency: Currency!) {
  commercetoolsProduct: inStore(key: $storeKey) {
    product(key: $key) {
      id
      productSelectionRefs(where: $distributionChannelWhereClause) {
        exists
      }
      key
      masterData {
        current {
          name(locale: $locale)
          description(locale: $locale)
          masterVariant {
            id
            images {
              url
              label
              dimensions {
                width
                height
              }
            }
            attributesRaw(
              includeNames: ["Gender", "ArticleNumber", "DominantColor", "ColorCode", "ProductNumber", "DominantColor", "BackgroundColor", "DescriptiveHeading"]
            ) {
              name
              value
            }
          }
          allVariants {
            id
            sku
            images {
              url
              label
              dimensions {
                width
                height
              }
            }
            price(channelId: $channelId, currency: $currency, country: $country) {
              value {
                currencyCode
                fractionDigits
                centAmount
              }
              discounted {
                value {
                  currencyCode
                  fractionDigits
                  centAmount
                }
              }
              custom {
                customFieldsRaw(
                  includeNames: ["price_CF_RecommendedRetailPrice", "price_CF_DiscountPercentage", "price_CF_AdjustedPrice", "price_CF_OfferIds"]
                ) {
                  name
                  value
                }
              }
            }
          }
        }
        published
      }
    }
  }
}
    `;
export const GetMasterProductsDocument = gql`
    query getMasterProducts($skus: [String!], $channelIds: [String!]) {
  products(skus: $skus) {
    results {
      id
      masterData {
        current {
          variants {
            sku
            attributesRaw(
              includeNames: ["Size", "MaterialGroupLocalized", "Size_CN", "Size_US", "Size_UK", "Size_KR", "Size_JP", "Size_CA", "Color"]
            ) {
              name
              value
            }
            availability {
              channels(includeChannelIds: $channelIds) {
                results {
                  channel {
                    id
                  }
                  availability {
                    isOnStock
                    availableQuantity
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetMyAddressesDocument = gql`
    query getMyAddresses {
  me {
    customer {
      ...CustomerAddressesFragment
    }
  }
}
    ${CustomerAddressesFragmentFragmentDoc}`;
export const GetMyProfileDocument = gql`
    query getMyProfile {
  me {
    customer {
      id
      version
      email
      firstName
      lastName
      dateOfBirth
      custom {
        customFieldsRaw(
          includeNames: ["customer_CF_PhoneCountryCode", "customer_CF_PhoneNumber", "customer_CF_Gender"]
        ) {
          name
          value
        }
      }
      ...CustomerAddressesFragment
    }
  }
}
    ${CustomerAddressesFragmentFragmentDoc}`;
export const GetOrderDocument = gql`
    query getOrder($id: String!, $locale: Locale!) {
  me {
    order(id: $id) {
      id
      orderNumber
      createdAt
      custom {
        customFieldsRaw(
          includeNames: ["order_CF_HasDiscount", "order_CF_DiscountedPrice", "order_CF_Price", "order_CF_Discount", "order_CF_DeliveryDate", "order_CF_DeliveryTimeSlot"]
        ) {
          name
          value
        }
      }
      lineItems {
        custom {
          customFieldsRaw(
            includeNames: ["line-item_CF_Price", "line-item_CF_DiscountedPrice"]
          ) {
            name
            value
          }
        }
        ...ProductFragment
      }
      taxedPrice {
        totalGross {
          ...MoneyFragment
        }
        totalTax {
          ...MoneyFragment
        }
      }
      totalPrice {
        ...MoneyFragment
      }
      shippingAddress {
        email
        phone
        ...AddressFragment
      }
      billingAddress {
        ...AddressFragment
      }
      shippingInfo {
        shippingMethodName
        shippingMethod {
          key
          name
          localizedName(locale: $locale)
        }
        price {
          ...MoneyFragment
        }
      }
      cart {
        shippingInfo {
          price {
            ...MoneyFragment
          }
          discountedPrice {
            value {
              ...MoneyFragment
            }
            includedDiscounts {
              discount {
                id
              }
              discountedAmount {
                centAmount
                currencyCode
                type
                fractionDigits
              }
            }
          }
        }
      }
      paymentInfo {
        payments {
          paymentMethodInfo {
            method
          }
          custom {
            customFieldsRaw {
              name
              value
            }
          }
          transactions {
            type
            state
          }
          interfaceInteractionsRaw {
            results {
              fields(includeNames: "notification") {
                name
                value
              }
            }
          }
        }
      }
      store {
        key
      }
    }
  }
}
    ${ProductFragmentFragmentDoc}
${MoneyFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;
export const ProductDetailsDocument = gql`
    query productDetails($sku: String!, $storeKey: KeyReferenceInput!, $channelId: String!, $distributionChannelWhereClause: String!, $currency: Currency!, $country: Country!, $commercetoolsLocale: Locale!, $sizeConventions: [String!]) {
  commercetoolsProduct: inStore(key: $storeKey) {
    product(
      sku: $sku
      localeProjection: [$commercetoolsLocale]
      projectExpandedProducts: true
    ) {
      id
      productSelectionRefs(where: $distributionChannelWhereClause) {
        exists
      }
      key
      masterData {
        current {
          name(locale: $commercetoolsLocale)
          description(locale: $commercetoolsLocale)
          masterVariant {
            images {
              url
              label
              dimensions {
                width
                height
              }
            }
            attributesRaw(
              includeNames: ["Gender", "ArticleNumber", "DominantColor", "ColorCode", "CountryOfOrigin", "CollectionSegment", "HowToUse", "NetQuantity", "ProductNumber", "CollectionCategory", "CollectionCategoryCode", "BackgroundColor", "FBStory", "FBText1", "FBText2", "FBText3", "FBText4", "FBText5", "FBText6", "DescriptiveHeading", "PageTitle", "MaterialGroupLocalized", "Division", "TargetGroup", "CollectionType", "CollectionClass", "ProductVideo", "InteractiveVideo", "CustomBadge1", "CustomBadge2", "CustomBadge3"]
            ) {
              name
              value
            }
          }
          variants {
            sku
            attributesRaw(includeNames: $sizeConventions) {
              name
              value
            }
            price(channelId: $channelId, currency: $currency, country: $country) {
              value {
                currencyCode
                fractionDigits
                centAmount
              }
              discounted {
                value {
                  currencyCode
                  fractionDigits
                  centAmount
                }
              }
              custom {
                customFieldsRaw(
                  includeNames: ["price_CF_RecommendedRetailPrice", "price_CF_DiscountPercentage", "price_CF_PreviousLowestPrice", "price_CF_DiscountPercentagePreviousLowestPrice", "price_CF_AdjustedPrice", "price_CF_OfferIds"]
                ) {
                  name
                  value
                }
              }
            }
            availability {
              channels {
                results {
                  channel {
                    id
                    key
                    roles
                  }
                  availability {
                    isOnStock
                    availableQuantity
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const EccoGetPaymentDocument = gql`
    query eccoGetPayment($id: String!) {
  payment(id: $id) {
    id
    custom {
      customFieldsRaw(includeNames: ["makePaymentResponse"]) {
        name
        value
      }
    }
  }
}
    `;
export const EccoShippingMethodsByCartDocument = gql`
    query eccoShippingMethodsByCart($cartId: String!) {
  shippingMethodsByCart(id: $cartId) {
    ...ShippingMethodFragment
  }
}
    ${ShippingMethodFragmentFragmentDoc}`;
export const EccoGetMyActiveWishlistDocument = gql`
    query eccoGetMyActiveWishlist($locale: Locale!) {
  me {
    shoppingLists(limit: 10) {
      results {
        ...WishlistFragment
      }
    }
  }
}
    ${WishlistFragmentFragmentDoc}`;
export type Requester<C = {}, E = unknown> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<ExecutionResult<R, E>> | AsyncIterable<ExecutionResult<R, E>>
export function getSdk<C, E>(requester: Requester<C, E>) {
  return {
    eccoCreateMyCart(variables: Types.EccoCreateMyCartMutationVariables, options?: C): Promise<ExecutionResult<Types.EccoCreateMyCartMutation, E>> {
      return requester<Types.EccoCreateMyCartMutation, Types.EccoCreateMyCartMutationVariables>(EccoCreateMyCartDocument, variables, options) as Promise<ExecutionResult<Types.EccoCreateMyCartMutation, E>>;
    },
    eccoAddProductToCart(variables: Types.EccoAddProductToCartMutationVariables, options?: C): Promise<ExecutionResult<Types.EccoAddProductToCartMutation, E>> {
      return requester<Types.EccoAddProductToCartMutation, Types.EccoAddProductToCartMutationVariables>(EccoAddProductToCartDocument, variables, options) as Promise<ExecutionResult<Types.EccoAddProductToCartMutation, E>>;
    },
    eccoUpdateLineItemSupplyChannel(variables: Types.EccoUpdateLineItemSupplyChannelMutationVariables, options?: C): Promise<ExecutionResult<Types.EccoUpdateLineItemSupplyChannelMutation, E>> {
      return requester<Types.EccoUpdateLineItemSupplyChannelMutation, Types.EccoUpdateLineItemSupplyChannelMutationVariables>(EccoUpdateLineItemSupplyChannelDocument, variables, options) as Promise<ExecutionResult<Types.EccoUpdateLineItemSupplyChannelMutation, E>>;
    },
    eccoUpdateShopperNameCustomFieldsCart(variables: Types.EccoUpdateShopperNameCustomFieldsCartMutationVariables, options?: C): Promise<ExecutionResult<Types.EccoUpdateShopperNameCustomFieldsCartMutation, E>> {
      return requester<Types.EccoUpdateShopperNameCustomFieldsCartMutation, Types.EccoUpdateShopperNameCustomFieldsCartMutationVariables>(EccoUpdateShopperNameCustomFieldsCartDocument, variables, options) as Promise<ExecutionResult<Types.EccoUpdateShopperNameCustomFieldsCartMutation, E>>;
    },
    eccoRemoveProductFromCart(variables: Types.EccoRemoveProductFromCartMutationVariables, options?: C): Promise<ExecutionResult<Types.EccoRemoveProductFromCartMutation, E>> {
      return requester<Types.EccoRemoveProductFromCartMutation, Types.EccoRemoveProductFromCartMutationVariables>(EccoRemoveProductFromCartDocument, variables, options) as Promise<ExecutionResult<Types.EccoRemoveProductFromCartMutation, E>>;
    },
    eccoAddDeliveryAddressToMyCart(variables: Types.EccoAddDeliveryAddressToMyCartMutationVariables, options?: C): Promise<ExecutionResult<Types.EccoAddDeliveryAddressToMyCartMutation, E>> {
      return requester<Types.EccoAddDeliveryAddressToMyCartMutation, Types.EccoAddDeliveryAddressToMyCartMutationVariables>(EccoAddDeliveryAddressToMyCartDocument, variables, options) as Promise<ExecutionResult<Types.EccoAddDeliveryAddressToMyCartMutation, E>>;
    },
    eccoAddDeliveryDateAndTimeSlotToCart(variables: Types.EccoAddDeliveryDateAndTimeSlotToCartMutationVariables, options?: C): Promise<ExecutionResult<Types.EccoAddDeliveryDateAndTimeSlotToCartMutation, E>> {
      return requester<Types.EccoAddDeliveryDateAndTimeSlotToCartMutation, Types.EccoAddDeliveryDateAndTimeSlotToCartMutationVariables>(EccoAddDeliveryDateAndTimeSlotToCartDocument, variables, options) as Promise<ExecutionResult<Types.EccoAddDeliveryDateAndTimeSlotToCartMutation, E>>;
    },
    eccoAddShippingMethodToCart(variables: Types.EccoAddShippingMethodToCartMutationVariables, options?: C): Promise<ExecutionResult<Types.EccoAddShippingMethodToCartMutation, E>> {
      return requester<Types.EccoAddShippingMethodToCartMutation, Types.EccoAddShippingMethodToCartMutationVariables>(EccoAddShippingMethodToCartDocument, variables, options) as Promise<ExecutionResult<Types.EccoAddShippingMethodToCartMutation, E>>;
    },
    eccoAddBillingAddressToMyCart(variables: Types.EccoAddBillingAddressToMyCartMutationVariables, options?: C): Promise<ExecutionResult<Types.EccoAddBillingAddressToMyCartMutation, E>> {
      return requester<Types.EccoAddBillingAddressToMyCartMutation, Types.EccoAddBillingAddressToMyCartMutationVariables>(EccoAddBillingAddressToMyCartDocument, variables, options) as Promise<ExecutionResult<Types.EccoAddBillingAddressToMyCartMutation, E>>;
    },
    eccoAddDiscountToCart(variables: Types.EccoAddDiscountToCartMutationVariables, options?: C): Promise<ExecutionResult<Types.EccoAddDiscountToCartMutation, E>> {
      return requester<Types.EccoAddDiscountToCartMutation, Types.EccoAddDiscountToCartMutationVariables>(EccoAddDiscountToCartDocument, variables, options) as Promise<ExecutionResult<Types.EccoAddDiscountToCartMutation, E>>;
    },
    eccoRemoveDiscountFromCart(variables: Types.EccoRemoveDiscountFromCartMutationVariables, options?: C): Promise<ExecutionResult<Types.EccoRemoveDiscountFromCartMutation, E>> {
      return requester<Types.EccoRemoveDiscountFromCartMutation, Types.EccoRemoveDiscountFromCartMutationVariables>(EccoRemoveDiscountFromCartDocument, variables, options) as Promise<ExecutionResult<Types.EccoRemoveDiscountFromCartMutation, E>>;
    },
    changeProductQuantityInCart(variables: Types.ChangeProductQuantityInCartMutationVariables, options?: C): Promise<ExecutionResult<Types.ChangeProductQuantityInCartMutation, E>> {
      return requester<Types.ChangeProductQuantityInCartMutation, Types.ChangeProductQuantityInCartMutationVariables>(ChangeProductQuantityInCartDocument, variables, options) as Promise<ExecutionResult<Types.ChangeProductQuantityInCartMutation, E>>;
    },
    changeProductSizeInCart(variables: Types.ChangeProductSizeInCartMutationVariables, options?: C): Promise<ExecutionResult<Types.ChangeProductSizeInCartMutation, E>> {
      return requester<Types.ChangeProductSizeInCartMutation, Types.ChangeProductSizeInCartMutationVariables>(ChangeProductSizeInCartDocument, variables, options) as Promise<ExecutionResult<Types.ChangeProductSizeInCartMutation, E>>;
    },
    changeProductSizeToExistOneInCart(variables: Types.ChangeProductSizeToExistOneInCartMutationVariables, options?: C): Promise<ExecutionResult<Types.ChangeProductSizeToExistOneInCartMutation, E>> {
      return requester<Types.ChangeProductSizeToExistOneInCartMutation, Types.ChangeProductSizeToExistOneInCartMutationVariables>(ChangeProductSizeToExistOneInCartDocument, variables, options) as Promise<ExecutionResult<Types.ChangeProductSizeToExistOneInCartMutation, E>>;
    },
    recalculateCart(variables: Types.RecalculateCartMutationVariables, options?: C): Promise<ExecutionResult<Types.RecalculateCartMutation, E>> {
      return requester<Types.RecalculateCartMutation, Types.RecalculateCartMutationVariables>(RecalculateCartDocument, variables, options) as Promise<ExecutionResult<Types.RecalculateCartMutation, E>>;
    },
    addAddressToCustomer(variables: Types.AddAddressToCustomerMutationVariables, options?: C): Promise<ExecutionResult<Types.AddAddressToCustomerMutation, E>> {
      return requester<Types.AddAddressToCustomerMutation, Types.AddAddressToCustomerMutationVariables>(AddAddressToCustomerDocument, variables, options) as Promise<ExecutionResult<Types.AddAddressToCustomerMutation, E>>;
    },
    updateAddressToCustomer(variables: Types.UpdateAddressToCustomerMutationVariables, options?: C): Promise<ExecutionResult<Types.UpdateAddressToCustomerMutation, E>> {
      return requester<Types.UpdateAddressToCustomerMutation, Types.UpdateAddressToCustomerMutationVariables>(UpdateAddressToCustomerDocument, variables, options) as Promise<ExecutionResult<Types.UpdateAddressToCustomerMutation, E>>;
    },
    updateDefaultShippingAddressToCustomer(variables: Types.UpdateDefaultShippingAddressToCustomerMutationVariables, options?: C): Promise<ExecutionResult<Types.UpdateDefaultShippingAddressToCustomerMutation, E>> {
      return requester<Types.UpdateDefaultShippingAddressToCustomerMutation, Types.UpdateDefaultShippingAddressToCustomerMutationVariables>(UpdateDefaultShippingAddressToCustomerDocument, variables, options) as Promise<ExecutionResult<Types.UpdateDefaultShippingAddressToCustomerMutation, E>>;
    },
    addDefaultShippingAddressToCustomer(variables: Types.AddDefaultShippingAddressToCustomerMutationVariables, options?: C): Promise<ExecutionResult<Types.AddDefaultShippingAddressToCustomerMutation, E>> {
      return requester<Types.AddDefaultShippingAddressToCustomerMutation, Types.AddDefaultShippingAddressToCustomerMutationVariables>(AddDefaultShippingAddressToCustomerDocument, variables, options) as Promise<ExecutionResult<Types.AddDefaultShippingAddressToCustomerMutation, E>>;
    },
    removeAddressById(variables: Types.RemoveAddressByIdMutationVariables, options?: C): Promise<ExecutionResult<Types.RemoveAddressByIdMutation, E>> {
      return requester<Types.RemoveAddressByIdMutation, Types.RemoveAddressByIdMutationVariables>(RemoveAddressByIdDocument, variables, options) as Promise<ExecutionResult<Types.RemoveAddressByIdMutation, E>>;
    },
    setDefaultShippingAddressById(variables: Types.SetDefaultShippingAddressByIdMutationVariables, options?: C): Promise<ExecutionResult<Types.SetDefaultShippingAddressByIdMutation, E>> {
      return requester<Types.SetDefaultShippingAddressByIdMutation, Types.SetDefaultShippingAddressByIdMutationVariables>(SetDefaultShippingAddressByIdDocument, variables, options) as Promise<ExecutionResult<Types.SetDefaultShippingAddressByIdMutation, E>>;
    },
    createMyWishlist(variables: Types.CreateMyWishlistMutationVariables, options?: C): Promise<ExecutionResult<Types.CreateMyWishlistMutation, E>> {
      return requester<Types.CreateMyWishlistMutation, Types.CreateMyWishlistMutationVariables>(CreateMyWishlistDocument, variables, options) as Promise<ExecutionResult<Types.CreateMyWishlistMutation, E>>;
    },
    deleteMyWishlist(variables: Types.DeleteMyWishlistMutationVariables, options?: C): Promise<ExecutionResult<Types.DeleteMyWishlistMutation, E>> {
      return requester<Types.DeleteMyWishlistMutation, Types.DeleteMyWishlistMutationVariables>(DeleteMyWishlistDocument, variables, options) as Promise<ExecutionResult<Types.DeleteMyWishlistMutation, E>>;
    },
    addProductToWishlist(variables: Types.AddProductToWishlistMutationVariables, options?: C): Promise<ExecutionResult<Types.AddProductToWishlistMutation, E>> {
      return requester<Types.AddProductToWishlistMutation, Types.AddProductToWishlistMutationVariables>(AddProductToWishlistDocument, variables, options) as Promise<ExecutionResult<Types.AddProductToWishlistMutation, E>>;
    },
    addProductAndRemoveOldest(variables: Types.AddProductAndRemoveOldestMutationVariables, options?: C): Promise<ExecutionResult<Types.AddProductAndRemoveOldestMutation, E>> {
      return requester<Types.AddProductAndRemoveOldestMutation, Types.AddProductAndRemoveOldestMutationVariables>(AddProductAndRemoveOldestDocument, variables, options) as Promise<ExecutionResult<Types.AddProductAndRemoveOldestMutation, E>>;
    },
    removeProductFromWishlist(variables: Types.RemoveProductFromWishlistMutationVariables, options?: C): Promise<ExecutionResult<Types.RemoveProductFromWishlistMutation, E>> {
      return requester<Types.RemoveProductFromWishlistMutation, Types.RemoveProductFromWishlistMutationVariables>(RemoveProductFromWishlistDocument, variables, options) as Promise<ExecutionResult<Types.RemoveProductFromWishlistMutation, E>>;
    },
    changeQuantityInWishlist(variables: Types.ChangeQuantityInWishlistMutationVariables, options?: C): Promise<ExecutionResult<Types.ChangeQuantityInWishlistMutation, E>> {
      return requester<Types.ChangeQuantityInWishlistMutation, Types.ChangeQuantityInWishlistMutationVariables>(ChangeQuantityInWishlistDocument, variables, options) as Promise<ExecutionResult<Types.ChangeQuantityInWishlistMutation, E>>;
    },
    changeProductSizeInWishlist(variables: Types.ChangeProductSizeInWishlistMutationVariables, options?: C): Promise<ExecutionResult<Types.ChangeProductSizeInWishlistMutation, E>> {
      return requester<Types.ChangeProductSizeInWishlistMutation, Types.ChangeProductSizeInWishlistMutationVariables>(ChangeProductSizeInWishlistDocument, variables, options) as Promise<ExecutionResult<Types.ChangeProductSizeInWishlistMutation, E>>;
    },
    eccoGetMyActiveCart(variables: Types.EccoGetMyActiveCartQueryVariables, options?: C): Promise<ExecutionResult<Types.EccoGetMyActiveCartQuery, E>> {
      return requester<Types.EccoGetMyActiveCartQuery, Types.EccoGetMyActiveCartQueryVariables>(EccoGetMyActiveCartDocument, variables, options) as Promise<ExecutionResult<Types.EccoGetMyActiveCartQuery, E>>;
    },
    eccoGetMyActiveData(variables: Types.EccoGetMyActiveDataQueryVariables, options?: C): Promise<ExecutionResult<Types.EccoGetMyActiveDataQuery, E>> {
      return requester<Types.EccoGetMyActiveDataQuery, Types.EccoGetMyActiveDataQueryVariables>(EccoGetMyActiveDataDocument, variables, options) as Promise<ExecutionResult<Types.EccoGetMyActiveDataQuery, E>>;
    },
    getCompactOrder(variables: Types.GetCompactOrderQueryVariables, options?: C): Promise<ExecutionResult<Types.GetCompactOrderQuery, E>> {
      return requester<Types.GetCompactOrderQuery, Types.GetCompactOrderQueryVariables>(GetCompactOrderDocument, variables, options) as Promise<ExecutionResult<Types.GetCompactOrderQuery, E>>;
    },
    getMultipleProductVariantsBySkus(variables: Types.GetMultipleProductVariantsBySkusQueryVariables, options?: C): Promise<ExecutionResult<Types.GetMultipleProductVariantsBySkusQuery, E>> {
      return requester<Types.GetMultipleProductVariantsBySkusQuery, Types.GetMultipleProductVariantsBySkusQueryVariables>(GetMultipleProductVariantsBySkusDocument, variables, options) as Promise<ExecutionResult<Types.GetMultipleProductVariantsBySkusQuery, E>>;
    },
    getMultipleProducts(variables: Types.GetMultipleProductsQueryVariables, options?: C): Promise<ExecutionResult<Types.GetMultipleProductsQuery, E>> {
      return requester<Types.GetMultipleProductsQuery, Types.GetMultipleProductsQueryVariables>(GetMultipleProductsDocument, variables, options) as Promise<ExecutionResult<Types.GetMultipleProductsQuery, E>>;
    },
    eccoGetProductByKey(variables: Types.EccoGetProductByKeyQueryVariables, options?: C): Promise<ExecutionResult<Types.EccoGetProductByKeyQuery, E>> {
      return requester<Types.EccoGetProductByKeyQuery, Types.EccoGetProductByKeyQueryVariables>(EccoGetProductByKeyDocument, variables, options) as Promise<ExecutionResult<Types.EccoGetProductByKeyQuery, E>>;
    },
    getMasterProducts(variables?: Types.GetMasterProductsQueryVariables, options?: C): Promise<ExecutionResult<Types.GetMasterProductsQuery, E>> {
      return requester<Types.GetMasterProductsQuery, Types.GetMasterProductsQueryVariables>(GetMasterProductsDocument, variables, options) as Promise<ExecutionResult<Types.GetMasterProductsQuery, E>>;
    },
    getMyAddresses(variables?: Types.GetMyAddressesQueryVariables, options?: C): Promise<ExecutionResult<Types.GetMyAddressesQuery, E>> {
      return requester<Types.GetMyAddressesQuery, Types.GetMyAddressesQueryVariables>(GetMyAddressesDocument, variables, options) as Promise<ExecutionResult<Types.GetMyAddressesQuery, E>>;
    },
    getMyProfile(variables?: Types.GetMyProfileQueryVariables, options?: C): Promise<ExecutionResult<Types.GetMyProfileQuery, E>> {
      return requester<Types.GetMyProfileQuery, Types.GetMyProfileQueryVariables>(GetMyProfileDocument, variables, options) as Promise<ExecutionResult<Types.GetMyProfileQuery, E>>;
    },
    getOrder(variables: Types.GetOrderQueryVariables, options?: C): Promise<ExecutionResult<Types.GetOrderQuery, E>> {
      return requester<Types.GetOrderQuery, Types.GetOrderQueryVariables>(GetOrderDocument, variables, options) as Promise<ExecutionResult<Types.GetOrderQuery, E>>;
    },
    productDetails(variables: Types.ProductDetailsQueryVariables, options?: C): Promise<ExecutionResult<Types.ProductDetailsQuery, E>> {
      return requester<Types.ProductDetailsQuery, Types.ProductDetailsQueryVariables>(ProductDetailsDocument, variables, options) as Promise<ExecutionResult<Types.ProductDetailsQuery, E>>;
    },
    eccoGetPayment(variables: Types.EccoGetPaymentQueryVariables, options?: C): Promise<ExecutionResult<Types.EccoGetPaymentQuery, E>> {
      return requester<Types.EccoGetPaymentQuery, Types.EccoGetPaymentQueryVariables>(EccoGetPaymentDocument, variables, options) as Promise<ExecutionResult<Types.EccoGetPaymentQuery, E>>;
    },
    eccoShippingMethodsByCart(variables: Types.EccoShippingMethodsByCartQueryVariables, options?: C): Promise<ExecutionResult<Types.EccoShippingMethodsByCartQuery, E>> {
      return requester<Types.EccoShippingMethodsByCartQuery, Types.EccoShippingMethodsByCartQueryVariables>(EccoShippingMethodsByCartDocument, variables, options) as Promise<ExecutionResult<Types.EccoShippingMethodsByCartQuery, E>>;
    },
    eccoGetMyActiveWishlist(variables: Types.EccoGetMyActiveWishlistQueryVariables, options?: C): Promise<ExecutionResult<Types.EccoGetMyActiveWishlistQuery, E>> {
      return requester<Types.EccoGetMyActiveWishlistQuery, Types.EccoGetMyActiveWishlistQueryVariables>(EccoGetMyActiveWishlistDocument, variables, options) as Promise<ExecutionResult<Types.EccoGetMyActiveWishlistQuery, E>>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;